<template>
    <div class="image-text-row container">
        <div class="row d-flex align-items-stretch">
            <div class="col-12 col-lg-5 align-self-center pb-40 py-lg-80 py-xl-120 py-xxl-160">
                <h2 class="mb-32" v-html="title"></h2>
                <div class="font-weight-light mb-32" v-html="description"></div>
                <a class="btn btn-accent" v-if="ctaLink" target="_blank" rel="noopener" :href="ctaLink">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
            </div>
            <div class="col-12 col-lg-6 offset-lg-1 align-self-stretch d-flex">
                <img v-if="image" class="img-cover w-100 h-100 mt-30 mt-lg-0" :src="image">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pagePart.image-text-row",

    props: {
        title: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            required: true,
        },
        cta: {
            type: String,
            default: 'col-12'
        },
        ctaLink: {
            type: String,
            required: false,
            default: null,
        },
        image: {
            type: String,
            required: true,
        },
    },
}
</script>